import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginSuperAdmin, loginAdmin } from '../services/authService';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is logged in on initial load
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    
    if (token && user) {
      setCurrentUser(JSON.parse(user));
      setIsAuthenticated(true);
    }
    
    setLoading(false);
  }, []);

  // const login = async (credentials, isSuperAdmin = false) => {
  //   try {
  //     setLoading(true);
  //     const response = isSuperAdmin 
  //       ? await loginSuperAdmin(credentials) 
  //       : await loginAdmin(credentials);
      
  //     const { token } = response;
      
  //     // Decode JWT to get user info
  //     const base64Url = token.split('.')[1];
  //     const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  //     const decodedToken = JSON.parse(window.atob(base64));
      
  //     const user = {
  //       id: decodedToken.id,
  //       role: decodedToken.role,
  //       isSuperAdmin: decodedToken.role === 'superadmin'
  //     };
      
  //     localStorage.setItem('token', token);
  //     localStorage.setItem('user', JSON.stringify(user));
      
  //     setCurrentUser(user);
  //     setIsAuthenticated(true);
  //     navigate('/');
      
  //     return true;
  //   } catch (error) {
  //     console.error('Login error:', error);
  //     return false;
  //   } finally {
  //     setLoading(false);
  //   }
  // };
const login = async (credentials) => {
  try {
    setLoading(true);
    const response = await loginSuperAdmin(credentials); // Only super admin login
    const { token } = response;

    // Decode JWT to get user info
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const decodedToken = JSON.parse(window.atob(base64));

    if (decodedToken.role !== 'superadmin') {
      throw new Error('Access denied: Only Super Admin can login');
    }

    const user = {
      id: decodedToken.id,
      role: decodedToken.role,
      isSuperAdmin: true,
    };

    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));

    setCurrentUser(user);
    setIsAuthenticated(true);
    navigate('/');
    return { success: true };
  } catch (error) {
    console.error('Super Admin Login error:', error);
    logout(); // Ensure cleanup
    return {
      success: false,
      message:
        error.response?.data?.message || 'Invalid credentials. Please try again.',
    };
  } finally {
    setLoading(false);
  }
};

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setCurrentUser(null);
    setIsAuthenticated(false);
    navigate('/login');
  };

  const value = {
    currentUser,
    isAuthenticated,
    loading,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};